import { useEffect } from "react";
import { Outlet, useLocation } from "react-router";
import { trackPageView } from "~/lib/analytics";

export function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return <Outlet />;
}
